/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaterialAddRequest
 */
export interface MaterialAddRequest {
    /**
     * 
     * @type {string}
     * @memberof MaterialAddRequest
     */
    classId: string;
    /**
     * 
     * @type {string}
     * @memberof MaterialAddRequest
     */
    materialType: MaterialAddRequestMaterialTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof MaterialAddRequest
     */
    availableDate: Date;
}


/**
 * @export
 */
export const MaterialAddRequestMaterialTypeEnum = {
    ClassMaterials: 'class materials',
    Recitation: 'recitation',
    RecitationAnswer: 'recitation answer'
} as const;
export type MaterialAddRequestMaterialTypeEnum = typeof MaterialAddRequestMaterialTypeEnum[keyof typeof MaterialAddRequestMaterialTypeEnum];


/**
 * Check if a given object implements the MaterialAddRequest interface.
 */
export function instanceOfMaterialAddRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;
    isInstance = isInstance && "materialType" in value;
    isInstance = isInstance && "availableDate" in value;

    return isInstance;
}

export function MaterialAddRequestFromJSON(json: any): MaterialAddRequest {
    return MaterialAddRequestFromJSONTyped(json, false);
}

export function MaterialAddRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialAddRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
        'materialType': json['materialType'],
        'availableDate': (new Date(json['availableDate'])),
    };
}

export function MaterialAddRequestToJSON(value?: MaterialAddRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
        'materialType': value.materialType,
        'availableDate': (value.availableDate.toISOString()),
    };
}

